<template>
  <div>
    <title-inv-1 title="Facturas"></title-inv-1>
    <cards-invoice style="margin-top: -24px"></cards-invoice>
    <title-inv-1
      title="Histórico Mensal"
      style="margin-top: -24px"
    ></title-inv-1>
    <month-historic></month-historic>
  </div>
</template>

<script>
import Title from "../geral/Title";
import CardsInvoice from "./invoices/CardsInvoice";
import MonthHistoric from "./invoices/MonthHistoric";
export default {
  name: "Facturas",
  components: { MonthHistoric, CardsInvoice, "title-inv-1": Title }
};
</script>

<style scoped></style>
